import variables from "../constants/assets/variables";
import _ from "lodash-es";
import { ar } from "date-fns/locale";
import { BYTES } from "../constants/FeatureConfig/constants";
import moment from 'moment';

export const constructApiUrl = (path) => {
  return `${process.env.REACT_APP_API_URL.replace(
    variables.routeEndpoint,
    ""
  )}/${path}`;
};

export const isMobile = () => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];
  return (
    toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    }) && window.innerWidth <= variables.breakPoint2
  );
};

export const getInitialState = (initialState, toResetState) => {
  if (Array.isArray(initialState[toResetState])) {
    return [];
  }
  switch (typeof initialState[toResetState]) {
    case "object":
      return {};
    case "string":
      return "";
    case "number":
      return 0;
    case "boolean":
      return false;
    default:
      return "";
  }
};

export const isValidated = (initialState, mandatoryFields) => {
  let err = "";
  Object.keys(initialState).map((key) => {
    if (mandatoryFields.includes(key)) {
      if (
        initialState[key] === undefined ||
        initialState[key] === null ||
        initialState[key] === "" ||
        (Array.isArray(initialState[key]) && initialState[key].length === 0)
      ) {
        err = `${key} field is mandatory`;
        return err;
      }
    }
  });
  return err ? err : "validated";
};

const mandatoryCheck = (key, val) => {
  var err = "";
  if (
    val === undefined ||
    val === null ||
    val === "" ||
    (Array.isArray(val) && val === 0)
  ) {
    err = `${key} field is mandatory`;
  }
  return err === "" ? true : err;
};

// form data is key value pairs
// validation mapping is key : function pair
// the function should accept field_name,key as paramater, ( check mandatoryCheck function)
// then during validation, field_name, and  value would be sent
// it should return true for success validation or any object as error
// exception, by sending "mandatory", the function would be set to mandatoryCheck
// finally this validateForm will return true, if all validation were true
// else return field: error_obj pairs.
export const validateForm = (formData, validationMappings) => {
  let err = {};
  Object.keys(validationMappings).forEach((key) => {
    if (validationMappings.hasOwnProperty(key)) {
      var validationFunction;
      if (typeof validationMappings[key].type === "function") {
        validationFunction = validationMappings[key];
      } else {
        if (validationMappings[key] === "mandatory") {
          validationFunction = mandatoryCheck;
        }
      }
      if (validationFunction) {
        let res = validationFunction(key, formData[key]);
        if (res !== true) {
          err[key] = res;
        }
      }
    }
  });
  return Object.keys(err).length === 0 ? true : err;
};

export const capitalizeFirstLetter = (stringInput) => {
  return stringInput.charAt(0).toUpperCase() + stringInput.slice(1);
};

export const getPath = (object, pathString, defaultValue) => {
  // Coerce pathString to a string (even it turns into "[object Object]").
  const parts = String(pathString).split(".");
  const { length } = parts;
  let i = 0;

  // In case object isn't a real object, set it to undefined.
  let value = object === Object(object) ? object : undefined;

  while (value != null && i < length) {
    value = value[parts[i]];
    i += 1;
  }
  return i && i === length && value !== undefined && value !== null
    ? value
    : defaultValue;
};

export const getReadableDateTime = (dateString) => {
  const dateObj = new Date(dateString);
  return `${dateObj.toDateString()} ${dateObj.toLocaleTimeString("en-us")}`;
};

export const getReadableDate = (dateString) => {
  const dateObj = new Date(dateString);
  return dateObj.toDateString();
};

export const addDays = (date, days) => {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const getSortedList = (list, key) => {
  if (list.length) {
    const newList = list.map((item) => item[key]);
    return newList.sort();
  } else {
    return [];
  }
};

export const getSortedListForStw = (list) => {
  if (list.length) {
    const newList = list.map(
      (item) =>
        "Name: " +
        item["name"] +
        " (Id: " +
        item["id"] +
        ", Category: " +
        item["category"] +
        ")"
    );
    return newList.sort();
  } else {
    return [];
  }
};

export const filterObj = (obj, requiredFields) => {
  const newObj = {};
  Object.keys(obj).forEach((val) => {
    if (requiredFields.includes(val)) {
      newObj[val] = obj[val];
    }
  });
  return newObj;
};

export const flattenObj = (obj, preserveArr = true, delimiter = ".") => {
  const flattenObj = {};
  const stack = [[obj, ""]];

  while (stack.length > 0) {
    const topItem = stack.pop();
    const curNode = topItem[0];
    let curKey = topItem[1];

    Object.keys(curNode).forEach((key) => {
      const nextKey = curKey ? `${curKey}${delimiter}${key}` : key;
      if (typeof curNode[key] === "object" && curNode[key] !== null) {
        if (Array.isArray(curNode[key]) === true && preserveArr === true) {
          flattenObj[nextKey] = curNode[key];
        } else {
          stack.push([curNode[key], nextKey]);
        }
      } else {
        flattenObj[nextKey] = curNode[key];
      }
    });
  }
  return flattenObj;
};

export const unFlattenObj = (obj, delimiter = ".") =>
  Object.keys(obj).reduce((result, curKey) => {
    curKey
      .split(delimiter)
      .reduce(
        (accumulator, curVal, curIdx, keys) =>
          accumulator[curVal] ||
          (accumulator[curVal] = isNaN(Number(keys[curIdx + 1]))
            ? keys.length - 1 === curIdx
              ? obj[curKey]
              : {}
            : []),
        result
      );
    return result;
  }, {});

export function debounce(func, delay) {
  var timer = null;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => func(...args), delay);
  };
}

export const throttle = (fn, wait) => {
  var time = Date.now();
  return function () {
    if (time + wait - Date.now() < 0) {
      fn();
      time = Date.now();
    }
  };
};

export const getQueryParams = (obj) => {
  let str = "";
  let flag = 0;
  const concatString = (key, embedValue) => {
    if (!flag) {
      str += `?${key}=${embedValue}`;
      flag = 1;
    } else {
      str += `&${key}=${embedValue}`;
    }
  };
  Object.keys(obj).map((key) => {
    if (Array.isArray(obj[key])) {
      for (let i = 0; i < obj[key].length; i++) {
        concatString(key, obj[key][i]);
      }
    } else {
      concatString(key, obj[key]);
    }
  });
  return str;
};

export const isEmpty = (obj) => {
  return Object.keys(obj).length === 0;
};

export const isEqual = (source, target) => {
  try {
    return JSON.stringify(source) === JSON.stringify(target);
  } catch (error) {
    console.log(error);
  }
  return false;
};

export const isValNull = (val) => {
  let isNull = false;
  if (Array.isArray(val) && val.length === 0) {
    isNull = true;
  }
  if (typeof val === "object" && val != null && Object.keys(val).length === 0) {
    isNull = true;
  }
  if (val === "" || val === null || val === undefined) {
    isNull = true;
  }
  return isNull;
};

export const isValidURL = (urlString) => {
  var urlPattern = new RegExp(
    "^((https?|ftp):\\/\\/)?" + // Validate protocol
      "(?:[a-zA-Z\\d-]{1,63}\\.)+" + // Validate domain name
      "(?:[a-zA-Z]{2,63}|\\d{1,3}(?:\\.\\d{1,3}){3})" + // Validate TLD or IPv4
      "(?::\\d+)?" + // Validate optional port
      "(?:\\/[^\\s]*)?" + // Validate optional path
      "(?:\\?[\\S]*)?" + // Validate optional query string
      "(?:#[\\S]*)?$", // Validate optional fragment locator
    "i" //for Case Insensitivity
  );

  return !!urlPattern.test(urlString);
};

export const isValidCustomDeeplink = (urlString) => {
  return !urlString.startsWith("driver_app");
};

export const getDateTimeAfter = (numDays, startDateTime = "") => {
  var xDaysFromNow = new Date();
  if (startDateTime) {
    xDaysFromNow = new Date(startDateTime);
  }
  xDaysFromNow.setDate(xDaysFromNow.getDate() + numDays);
  xDaysFromNow.setHours(xDaysFromNow.getHours() + 5);
  xDaysFromNow.setMinutes(xDaysFromNow.getMinutes() + 30);
  var requiredDateTime = xDaysFromNow.toISOString().slice(0, 16);
  return requiredDateTime;
};

export const removeEmptyVals = (obj) => {
  const newObj = {};
  Object.keys(obj).map((key) => {
    if (!isValNull(obj[key])) {
      newObj[key] = obj[key];
    }
    if (
      typeof obj[key] === "object" &&
      !Array.isArray(obj[key]) &&
      !isValNull(obj[key])
    ) {
      const updatedObj = removeEmptyVals(obj[key]);
      newObj[key] = updatedObj;
      if (isValNull(newObj[key])) {
        delete newObj[key];
      }
    }
  });
  return newObj;
};

export const isObjectStateEmpty = (obj) => {
  let flag = true;
  Object.keys(obj).forEach((key) => {
    if (!isValNull(obj[key])) {
      flag = false;
    }
  });
  return flag;
};

//check if object is completely filled, all values are present
export const isObjectAllEntriesPresent = (obj) => {
  let flag = true;
  Object.keys(obj).forEach((key) => {
    if (isValNull(obj[key])) {
      flag = false;
    }
  });
  return flag;
};

export const isObject = (val) => {
  return typeof val === "object" && !Array.isArray(val);
};

export function getLocalTimeFromEpoch(epochTimestamp) {
  // Create a new Date object using the epoch timestamp (in milliseconds)
  const date = new Date(epochTimestamp * 1000);

  // Get the components of the local date and time
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  // Construct the string representation of the local time
  const localTime =
    year +
    "-" +
    month +
    "-" +
    day +
    " " +
    hours +
    ":" +
    minutes +
    ":" +
    seconds;

  return localTime;
}

//recursive function to carry out the difference between 2 objects
//Useful in comparing two objects and post those keys only that has changed, it will reduce payload size in http requests
export const getObjectsDifference = (
  existingObj = {},
  newObj = {},
  mandatoryKey
) => {
  let diff = {};
  Object.keys(newObj).map((key) => {
    if (newObj[key] && isObject(newObj[key])) {
      const diffObj = getObjectsDifference(
        existingObj[key],
        newObj[key],
        mandatoryKey
      );
      if (Object.keys(diffObj).length > 0) {
        diff[key] = { ...diffObj };
      }
    } else {
      if (
        JSON.stringify(getPath(existingObj, key, undefined)) !==
        JSON.stringify(getPath(newObj, key, undefined))
      ) {
        diff[key] = newObj[key];
      }
    }
  });
  if (mandatoryKey !== undefined && Object.keys(diff).length > 0) {
    diff[mandatoryKey] = newObj[mandatoryKey];
  }
  return diff;
};

export const addMandatoryNestedKeys = (diff, newObj, nestedMandatoryKey) => {
  if (nestedMandatoryKey !== undefined && Object.keys(diff).length > 0) {

    for (const key of nestedMandatoryKey) {
      const parentKey = key.split(".").slice(0, -1).join(".");
      if (parentKey && _.get(diff, parentKey, undefined) !== undefined) {
        _.set(diff, key, _.get(newObj, key));
      }
    }
  }
}

export const setNestedKeyValue = (payload, nestedString, value) => {
  const keyArr = nestedString.split(".");
  let val = "";
  for (let i = 0; i < keyArr.length - 1; i++) {
    if (val === "") {
      if (!payload[keyArr[i]]) {
        payload[keyArr[i]] = {};
      }
      val = payload[keyArr[i]];
    } else {
      if (!val[keyArr[i]]) {
        val[keyArr[i]] = {};
      }
      val = val[keyArr[i]];
    }
  }
  if (val === "" || keyArr.length === 0) {
    payload[nestedString] = value;
  } else {
    if (!val[keyArr[keyArr.length - 1]]) {
      val[keyArr[keyArr.length - 1]] = {};
    }
    val[keyArr[keyArr.length - 1]] = value;
  }
};

//will return true in any one key is present in obj from a array of keys
export const checkIfKeysPresent = (obj, keys) => {
  let flag = 0;
  for (let i = 0; i < keys.length; i++) {
    if (!isValNull(obj[keys[i]])) {
      flag = 1;
      break;
    }
  }
  return flag;
};

export const removeSymbolfromString = (str, symbol) => {
  return str.split(`${symbol}`).join(" ");
};

export const getKeyValueInNestedObject = (obj, valKey) => {
  if (obj[valKey]) {
    return obj[valKey];
  }
  function recursivelyFindProp(objt, keyToBeFound) {
    let result = "";
    for (const key of Object.keys(objt)) {
      if (
        !isValNull(objt[key]) &&
        !Array.isArray(objt[key]) &&
        typeof objt[key] === "object"
      ) {
        result = recursivelyFindProp(objt[key], keyToBeFound);
        if (result !== "") break;
      } else if (_.hasIn(objt, keyToBeFound)) {
        return _.get(objt, keyToBeFound);
      }
    }
    if (typeof result === "object") {
      return "";
    }
    return result;
  }

  return recursivelyFindProp(obj, valKey) || "";
};

export const exportToCSV = (csvData) => {
  const csvContent = "data:text/csv;charset=utf-8," + csvData;
  const encodedUri = encodeURI(csvContent);
  window.open(encodedUri);
};

export const deleteCookies = (cookiesToExclude) => {
  var cookies = document.cookie.split("; ");
  for (var c = 0; c < cookies.length; c++) {
    var cookieName = cookies[c].split("=")[0];
    if (!cookiesToExclude.includes(cookieName)) {
      // Check if it's a cookie to exclude
      var d = window.location.hostname.split(".");
      while (d.length > 0) {
        var cookieBase =
          encodeURIComponent(cookieName) +
          "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
          d.join(".") +
          " ;path=";
        var p = window.location.pathname.split("/");
        document.cookie = cookieBase + "/";
        while (p.length > 0) {
          document.cookie = cookieBase + p.join("/");
          p.pop();
        }
        d.shift();
      }
    }
  }
};

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const validateStoreId = (storeId) => {
  return String(storeId).match(/^\d+$/);
};

export const validatePhone = (phone) => {
  return String(phone)
    .toLowerCase()
    .match(/^[0-9]{10}$/);
};

export const validateIndianPhone = (phone) => {
  return String(phone)
    .toLowerCase()
    .match(/^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[0-9]\d{9}$/);
};

export const validatePercentage = (percentage) => {
  const num = parseFloat(percentage);
  if (!Number.isNaN(num) && num >= 0 && num <= 100) {
    return /^(\d{1,2}(\.\d{1,2})?|100(\.00?)?)$/.test(num.toFixed(2));
  }
  return false;
};

export const isDSMDropdownEnabled = (modalState = "") => {
  return modalState.toLowerCase() !== "filter";
};

export const parseString = (string) => {
  try {
    return JSON.parse(string);
  } catch (e) {
    return null;
  }
};

export const getServiceIdsFromConditions = (conditions) => {
  conditions =
    typeof conditions === "object" ? conditions : parseString(conditions);
  const serviceIdConditions = _.filter(conditions, ["Name", "service_id"]);
  return _.get(serviceIdConditions, ["0", "Value"], []);
};

export const isServiceIdConditionPresent = (feature, serviceIds) => {
  const currentServiceIds = getServiceIdsFromConditions(
    feature.conditions,
    serviceIds
  );
  return (
    _.intersection(serviceIds, currentServiceIds).length == serviceIds.length
  );
};

export const pushOrUpdate = (arr = [], condition, newElement) => {
  arr = removeCondition(arr, condition);
  arr.push(newElement);
  return arr;
};

export const removeCondition = (arr, condition) => {
  if (!Array.isArray(arr)) {
    return [];
  }
  const index = _.findIndex(arr, condition);
  if (index >= 0) {
    arr.splice(index, 1);
  }
  return arr;
};

export const isUrlValid = (strings = []) => {
  try {
    for (const index in strings) {
      new URL(strings[index]);
    }
    return true;
  } catch (err) {
    return false;
  }
};

export function toLocaleDateString(date) {
  const originalDate = new Date(date);
  // Extract the components of the date (year, month, day, hours, minutes)
  const year = originalDate.getFullYear();
  const month = ("0" + (originalDate.getMonth() + 1)).slice(-2); // Months are zero-based
  const day = ("0" + originalDate.getDate()).slice(-2);
  const hours = ("0" + originalDate.getHours()).slice(-2);
  const minutes = ("0" + originalDate.getMinutes()).slice(-2);
  // Create a new date string in the desired format
  const newDateString =
    year + "-" + month + "-" + day + "T" + hours + ":" + minutes;
  return newDateString;
}

export function generateFileName(identifier = "", ext, prefix) {
  return `${prefix ? prefix + "_" : ""}${identifier?.slice(0, 15)}.${ext}`
    .toLowerCase()
    .replace(/ /g, "_");
}

export function convertValueByDataType(dataType, value) {
  switch (dataType) {
    case "int64":
      return parseInt(value);
    case "float64":
      return parseFloat(value);
    case "string":
      return String(value);
    case "json":
      return JSON.parse(value);
    case "bool":
      return `${value}`.toLowerCase() === "true";
    case "time":
      return parseInt(value);
    default:
      // Handle unsupported types or return as is
      return value;
  }
}
// can use this for generating random id's, quick replacement for nanoid
export const getRandomId = () => {
  return parseInt(new Date().getTime() * Math.random());
};

export function isFloat(value) {
  // If the value is not a number, check if it is a string that represents a float
  if (typeof value === "string") {
    // Use a regular expression to check if the string is a float
    const regex = /^[+-]?\d*\.\d+$/;
    return regex.test(value.trim());
  }

  // If the value is neither a number nor a valid float string, return false
  return false;
}

export const getFormattedFileSize = (size) => {
  if (!size) return "-";
  if (size >= BYTES.MB) {
    return `${(size / BYTES.MB).toFixed(2)} MB`;
  } else if (size >= BYTES.KB) {
    return `${(size / BYTES.KB).toFixed(2)} KB`;
  } else {
    return `${size} bytes`;
  }
};

export const getFormattedISODateString = (isoDateString) => {
  if (!isoDateString || typeof isoDateString !== 'string' || isoDateString == 
    "1970-01-01 05:30:00") {
    return "-";
  }

  const date = new Date(isoDateString);
  if (isNaN(date.getTime())) {
    return "-";
  }
  return moment(date).format("MMM DD, YYYY hh:mm A");
};

export const filterKeys = (rowData, excludedKeys) => {
  if (!Array.isArray(rowData)) return [];
  return rowData.filter(data => !excludedKeys.includes(data.key));
};

export const protoTimestampToIST = (seconds) => {
  return moment.unix(seconds).utcOffset('+05:30').format('dddd, YYYY-MM-DD HH:mm:ss');
};